import { useEffect, useRef } from 'react';
import '../../styles/components/LogViewer.scss';

const LogViewer = ({ logs, isSyncing }) => {
  const preRef = useRef(null);

  useEffect(() => {
    if (preRef.current) {
      preRef.current.scrollTop = preRef.current.scrollHeight;
    }
  }, [logs]);

  return (
    <div className="log-viewer">
      <div className="log-viewer__header">
        <span className="log-viewer__dot" />
        <span className="log-viewer__dot" />
        <span className="log-viewer__dot" />
        <h3>Log de proceso</h3>
      </div>
      <pre ref={preRef} className="log-viewer__pre">
        {logs.length === 0 && (
          <span style={{ color: '#484F58' }}>{'// esperando sincronización...'}</span>
        )}
        {logs.map((log, i) => (
          <div key={i} className={`log-entry log-entry--${log.level}`}>
            <span className="log-entry__timestamp">{new Date(log.timestamp).toLocaleTimeString()}</span>
            <span className="log-entry__provider">[{log.provider}]</span>
            <span className="log-entry__message">{log.message}</span>
          </div>
        ))}
        {isSyncing && logs.length > 0 && (
          <div className="log-entry log-entry--info">
            <span className="log-entry__message">↻ Sincronización en proceso...</span>
          </div>
        )}
      </pre>
    </div>
  );
};

export default LogViewer;
